// extracted by mini-css-extract-plugin
export default {"channel_logo_block":"CardChannelSubnav_channel_logo_block__0W++q","active":"CardChannelSubnav_active__oWvm0","channel_logo":"CardChannelSubnav_channel_logo__M6B4V"};